import React from 'react';
import { useMutation } from '@apollo/client';
// graphql
import PropTypes from 'prop-types';
import { ErrorHandler } from '@playbookux/playbook-web-core';
import { updateTestSession, REMOVE_TEST_SESSION } from '../graphql';
// styles
import {
  Modal, ModalHeader, ModalText, ModalFooter, ModalButton, Container, Loader,
} from '../styles';

function RemoveModal({
  open,
  handleCloseModal,
  testSession,
  projectId,
  refetchTestSessions,
  refetchLoading,
  refetch,
}) {
  const [removeTestSessionMutation, { error, loading }] = useMutation(REMOVE_TEST_SESSION, {
    update: updateTestSession(projectId),
    onCompleted: refetch,
  });

  if (!testSession) {
    return null;
  }

  const handleRemoveTestSession = async () => {
    if (testSession) {
      await removeTestSessionMutation({
        variables: {
          id: testSession.id,
          removed: true,
        },
      });

      refetchTestSessions();
    }
    handleCloseModal();
  };

  if (loading || refetchLoading) {
    return (
      <Container>
        <Loader size="small" data-loader="remove-modal-loader" />
      </Container>
    );
  }

  if (error) {
    return (
      <ErrorHandler
        error={error}
        defaultMessage="Error while retrieving the testers."
      />
    );
  }

  return (
    <Modal open={open} onClose={handleCloseModal} size="tiny">
      <ModalHeader>
        Do you want to remove this test session?
      </ModalHeader>

      <ModalText>The invite to the client and tester will be cancelled</ModalText>

      <ModalFooter>
        <ModalButton onClick={() => handleRemoveTestSession()}>Yes</ModalButton>
        <ModalButton onClick={() => handleCloseModal()}>No</ModalButton>
      </ModalFooter>
    </Modal>
  );
}

RemoveModal.propTypes = {
  open: PropTypes.bool.isRequired,
  refetchLoading: PropTypes.bool.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  refetchTestSessions: PropTypes.func.isRequired,
  testSession: PropTypes.shape({ id: PropTypes.string.isRequired }).isRequired,
  projectId: PropTypes.string.isRequired,
  refetch: PropTypes.func.isRequired,
};

export default RemoveModal;
